// components/layout/MobileMenu.jsx
import { useSelector, useDispatch } from 'react-redux';
import { closeNav } from '../../features/nav/navslice'
import { Link } from 'react-router-dom';

export default function MobileMenu() {
  const { isOpen } = useSelector((state) => state.nav);
  const dispatch = useDispatch();

  return (
    <div
      className={`fixed inset-0 z-40 bg-black/95 transition-transform duration-300 ${
        isOpen ? 'translate-x-0' : 'translate-x-full'
      }`}
    >
      <div className="p-6">
        <button onClick={() => dispatch(closeNav())}>✕</button>

        <nav className="mt-10 flex flex-col gap-6 text-xl text-white">
          <Link to="/" onClick={() => dispatch(closeNav())}>Home</Link>
          <Link to="/solutions" onClick={() => dispatch(closeNav())}>Solutions</Link>
          <Link to="/about-us" onClick={() => dispatch(closeNav())}>About</Link>
          <Link to="/sectors" onClick={() => dispatch(closeNav())}>Sectors</Link>
          <Link to="/why-choose-us" onClick={() => dispatch(closeNav())}>Why Choose Us</Link>
          <Link to="/contact-us" onClick={() => dispatch(closeNav())}>Contact Us</Link>
        </nav>
      </div>
    </div>
  );
}